"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPISODIC_WINDOW = exports.EPISODIC_WINDOW_DAYS = void 0;
exports.episodicDeadline = episodicDeadline;
exports.episodicLimit = episodicLimit;
const wasteAccumulation_1 = require("encamp-shared/dist/constants/wasteAccumulation");
Object.defineProperty(exports, "EPISODIC_WINDOW_DAYS", { enumerable: true, get: function () { return wasteAccumulation_1.EPISODIC_WINDOW_DAYS; } });
const date_1 = require("encamp-shared/dist/utils/date");
const relief_1 = require("./relief");
/**
 * 60 days from the EVENT's start, not the container's. Federal-stamped
 * everywhere: a state either grants this provision or grants nothing.
 */
exports.EPISODIC_WINDOW = {
    kind: "TIME",
    days: wasteAccumulation_1.EPISODIC_WINDOW_DAYS,
    citation: "40 CFR 262 subpart L",
    jurisdiction: "FEDERAL",
};
/** Always exactly `startDate + EPISODIC_WINDOW_DAYS` at UTC midnight; never persisted. */
function episodicDeadline(eventStartDate) {
    return (0, date_1.addUtcDays)((0, date_1.floorToUtcMidnight)(eventStartDate), wasteAccumulation_1.EPISODIC_WINDOW_DAYS);
}
/**
 * The episodic limit for one container, or null where none applies. Reads
 * attachment and state adoption only (see `index.ts`); the composition step
 * in `computeContainerClock` takes the sooner of this and the standing clock.
 * Area-blind: at a satellite area the window sits alongside the SAA caps.
 */
function episodicLimit(query) {
    if (query.activeEpisodicEvent === null || !(0, relief_1.episodicEventsApplicableForState)(query.state)) {
        return null;
    }
    return {
        limit: exports.EPISODIC_WINDOW,
        anchorDate: (0, date_1.floorToUtcMidnight)(query.activeEpisodicEvent.startDate),
    };
}
//# sourceMappingURL=window.js.map